import { memo, ReactElement, useCallback, useMemo } from 'react';
import { BaseFilterChip } from './BaseFilterChip';
import { FilterChipProps } from './common';
import { NumberRangeFilterProps } from '../Primitives/NumberRangeFilter';
import { useTranslation } from 'react-i18next';

export const NumberRangeFilterChip = memo(function ({
  displayName,
  onValueChange,
  value,
  unitName,
}: FilterChipProps<NumberRangeFilterProps>): ReactElement {
  const { t } = useTranslation();
  const handleRemove = useCallback(
    function (): void {
      if (onValueChange) {
        onValueChange(undefined);
      }
    },
    [onValueChange]
  );

  const filterValueText = useMemo(
    function (): string {
      if (value?.range?.gte !== undefined && value?.range?.lte !== undefined) {
        return t('filter.numberRange.between', { gte: value.range.gte, lte: value.range.lte, unit: unitName });
      } else if (value?.range?.gte !== undefined) {
        return t('filter.numberRange.from', { gte: value.range.gte, unit: unitName });
      } else if (value?.range?.lte !== undefined) {
        return t('filter.numberRange.to', { lte: value?.range?.lte, unit: unitName });
      } else {
        return '';
      }
    },
    [value, unitName, t]
  );

  return (
    <>
      {value && (
        <BaseFilterChip onRemove={handleRemove}>
          {t(displayName)}: {filterValueText}
        </BaseFilterChip>
      )}
    </>
  );
});
